<template>
  <div v-loading="!contragent" class="contract-contragent">
    <div class="contract-contragent__header">
      <status-list
        :is-actual-and-download="isActualAndDownload"
        :is-signed-and-download="isSignedAndDownload"
        :is-signed="isSigned"
        :is-download="isDownload"
        :get-actual-date="getActualDate"
      />
    </div>
    <upload-doc-and-create-contract-modal
      v-if="contragentContracts"
      ref="uploadDocumentModal"
      :short_name="performer.short_name"
      :loading-contracts="loadingUpdate"
      :contragent-contracts="contragentContracts[performer.inn]"
      :object-data="objectData"
      :data-edit="dataEdit"
      :inn="performer.inn"
      :source-id="dataEdit.sourceId"
      :need-additional="true"
      :advanced-info="advanceInfoData"
      :contragent-id="contragent.id"
      :response-contract="responseContract"
      :contragent-org-inn="contragent.user_org_inn"
      @createdContract="createContract"
      @createdDocument="createDocument"
      @deletedDocument="deleteDocument"
      @deletedFile="deleteFile"
      @signedDocument="signDocument"
      @setedActiveDocument="setActiveDocument"
      @uploadImages="uploadImages"
      @getedZip="getedZip"
      @savedNumber="savedNumber"
      @updatedTypeContarct="updateTypeContarct"
    />
    <el-row class="contract-contragent__print">
      <p class="contract-contragent__print-title">Распечатать:</p>
      <print-contract
        :proxy="proxy"
        :contragent="contragent"
        :inn="performer.inn"
      />
      <el-button type="primary" @click="setModal(1)">
        Доп. соглашение
      </el-button>
      <print-contract
        text="Договор PDF "
        :proxy="proxy"
        :contragent="contragent"
        :inn="performer.inn"
        as-pdf
      />
      <print-contract
        v-if="performer.id === 13815"
        text="Договор PDF с печатью"
        :contragent="contragent"
        :inn="performer.inn"
        :proxy="proxy"
        as-pdf
        with-sign
      />
    </el-row>
    <print-extension-modal
      :id="contragent.id"
      :visible="extensionDialog"
      :inn="performer.inn"
      @close="setModal()"
    />
  </div>
</template>

<script>
import {
  ADD_CONTRACT,
  ADD_DOCUMENT,
  ADD_TYPE_CONTRACT,
  DELETE_DOCUMENT,
  DELETE_FILE_DOCUMENT,
  FETCH_CONTRACTS,
  RENAME_DOCUMENT,
  SET_ACTIVE_DOCUMENT,
  SIGN_DOCUMENT,
  UPLOAD_FILE_IMG_DOCUMENT,
} from '@/store/actions/contracts'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import { mapActions, mapGetters } from 'vuex'
import PrintContract from './PrintContract'
import PrintExtensionModal from './Modals/PrintExtensionModal'
import StatusList from '@/views/Contragents/StatusList'
import UploadDocAndCreateContractModal from '@/components/Upload/UploadDocAndCreateContractModal/index'
const DocumentRepository = RepositoryFactory.get('document')

export default {
  name: 'ContractContragent',
  components: {
    StatusList,
    UploadDocAndCreateContractModal,
    PrintContract,
    PrintExtensionModal,
  },
  mixins: [filesValidateMixinChildActions],
  props: {
    contragent: {
      type: Object,
      default: () => {},
    },
    performer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      proxy: {},
      objectData: {},
      sourceId: null,
      advanceInfoData: {
        inn: {
          title: 'ИНН',
          fieldName: 'inn',
        },
        org_name: {
          title: 'Наименование',
          fieldName: 'org_name',
        },
      },
      dataEdit: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'contract', // СРСТ
      },
      contract: {
        contragent_inn: '',
        user_org_inn: '',
      },
      contracts: [],
      responseContract: {},
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'договор с контрагентом',
        childFilesCountProperty: 'countFiles',
      },
      extensionDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      loadingUpdate: 'getContragentLoadingUpdate',
      loadingContracts: 'getContractsLoading',
      oneContragent: 'getContragent',
    }),
    contragentContracts() {
      return this.contragent ? this.contragent.contracts : null
    },
    isActualAndDownload() {
      const inn = this.performer.inn

      return Boolean(
        this.contragentContracts &&
          this.contragentContracts[inn] &&
          this.contragentContracts[inn]?.current_document &&
          this.contragentContracts[inn]?.current_document?.is_current,
      )
    },
    isSignedAndDownload() {
      return Boolean(
        this.contragentContracts &&
          this.contragentContracts[this.performer.inn] &&
          this.contragentContracts[this.performer.inn]?.current_document?.files
            .length > 0 &&
          this.contragentContracts[this.performer.inn]?.current_document
            ?.is_signed,
      )
    },
    isDownload() {
      return Boolean(
        this.contragentContracts &&
          this.contragentContracts[this.performer.inn] &&
          this.contragentContracts[this.performer.inn]?.current_document?.files
            .length > 0,
      )
    },
    isSigned() {
      return Boolean(
        this.contragentContracts &&
          this.contragentContracts[this.performer.inn] &&
          this.contragentContracts[this.performer.inn]?.current_document
            ?.is_signed,
      )
    },
    getActualDate() {
      return (
        (this.contragentContracts &&
          this.dateToFormat(
            this.contragentContracts[this.performer.inn]
              ?.documents_workflow_updated_at,
          )) ||
        'нет данных'
      )
    },
  },
  watch: {
    contragent: {
      immediate: true,
      handler(newVal) {
        this.getProxy()
        this.objectData = newVal
        this.dataEdit.sourceId = newVal.id
        this.sourceId = newVal.id
        this.contract.contragent_inn = newVal.inn
        this.contract.user_org_inn = this.cur_org_inn
      },
    },
  },
  methods: {
    ...mapActions({
      getContracts: FETCH_CONTRACTS,
      createContragentContract: ADD_CONTRACT,
      createContragentDocument: ADD_DOCUMENT,
      deleteContragentDocument: DELETE_DOCUMENT,
      signContragentDocument: SIGN_DOCUMENT,
      setActiveContractDocument: SET_ACTIVE_DOCUMENT,
      deleteFileContractDocument: DELETE_FILE_DOCUMENT,
      uploadFileImgDocument: UPLOAD_FILE_IMG_DOCUMENT,
      renameFileDocument: RENAME_DOCUMENT,
      addTypeContract: ADD_TYPE_CONTRACT,
    }),
    updateTypeContarct(data) {
      this.$emit('updateContract')
      this.addTypeContract({ ...data, inn: this.contragent.inn })
    },
    uploadImages(param1, param2) {
      this.$store.dispatch('fetchContragentByInn', this.contragent.inn)
      this.uploadFileImgDocument(param1, param2).then(() =>
        this.$store.dispatch('fetchContragentByInn', this.contragent.inn),
      )
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'file.zip') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    getedZip(document_id) {
      this.downloadRegistry({
        path: DocumentRepository.getZipUrl(document_id),
        blank: 1,
      })
    },

    setModal(flag = 0) {
      this.extensionDialog = Boolean(flag)
    },
    // Создаем новый контракт

    createContract() {
      this.$emit('updateContract')

      this.createContragentContract({
        contragent_id: this.contragent.id,
        exporter_org_inn: this.performer.inn,
        inn: this.contragent.inn,
      })
    },
    savedNumber(data) {
      this.$emit('updateContract')
      this.renameFileDocument({ ...data, inn: this.contragent.inn })
    },
    deleteDocument(data) {
      this.$emit('updateContract')
      this.deleteContragentDocument({ ...data, inn: this.contragent.inn })
    },
    deleteFile(data) {
      if (data.constructor === Array) {
        data.map(id =>
          this.deleteFileContractDocument(id).then(() =>
            this.$store.dispatch('fetchContragentByInn', this.contragent.inn),
          ),
        )
      } else {
        this.deleteFileContractDocument({ ...data, inn: this.contragent.inn })
      }
    },
    createDocument(data) {
      this.$emit('updateContract')
      this.createContragentDocument({ ...data, inn: this.contragent.inn })
    },
    signDocument(data) {
      this.$emit('updateContract')
      this.signContragentDocument({ ...data, inn: this.contragent.inn })
    },
    setActiveDocument(data) {
      this.$emit('updateContract')
      this.setActiveContractDocument({ ...data, inn: this.contragent.inn })
    },
    getProxy() {
      if (this.curUserOrgId) {
        DocumentRepository.getDocument('users', this.curUserOrgId, 'proxy_doc')
          .then(res => {
            const { status, data } = res

            this.proxy =
              status === 200 && data?.length ? this.getApproveOneDoc(data) : {}
          })
          .catch(err => this.errHandler(err))
      }
    },
    getApproveOneDoc(doc) {
      let documentItem
      const res = {}

      for (let key in doc) {
        if (documentItem === undefined) {
          documentItem = doc[key]
        }
        if (doc[key].approve_status.length !== 0) {
          documentItem = doc[key]
        }
      }

      if (documentItem) {
        const { comment, number, document_create_date: date } = documentItem

        if (comment) {
          res.v_lice = comment
        }
        if (number) {
          res.proxy_doc_num = 'доверенности номер ' + number
        }
        if (date) {
          res.proxy_doc_date = date
        }
      }

      return res
    },
  },
}
</script>

<style lang="sass">
.contract-contragent
  &__header
    font-family: "Rubik", sans-serif
    display: flex
    flex-direction: column
    align-items: start
    justify-content: start
    h2
      margin-bottom: 0
  &__print
  &__print-title
    font-size: 16px
    color: #606266
    margin: 0
    .el-button
      margin-bottom: 10px
      margin-right: 10px
    .el-button+.el-button
      margin-left: 0
</style>
